import { ReportCommonFilterComponent } from './components/report-common-filter/report-common-filter.component';
import { IotIntelligenceCardComponent } from './components/iot-intelligence-card/iot-intelligence-card.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material/material.module';
import { LoaderComponent } from './components/loader/loader.component';
import { MatSnackbarComponent } from './components/mat-snackbar/mat-snackbar.component';
import { SvgToMatIconPipe } from '../common/Pipe/svg-to-mat-icon.pipe';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { HeaderComponent } from './components/header/header.component';
import { RouterModule } from '@angular/router';
import { FormErrorMessageComponent } from './components/form-error-message/form-error-message.component';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { MapComponent } from './components/map/map.component';
import { TableComponent } from './components/table/table.component';
import { TextTruncatePipe } from '../common/Pipe/text-truncate.pipe';
import { ModalHeaderComponent } from './components/modal-header/modal-header.component';
import { ModalFooterComponent } from './components/modal-footer/modal-footer.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { PaginatorModule } from 'primeng/paginator';
import { LineSkeletonLoaderComponent } from './components/line-skeleton-loader/line-skeleton-loader.component';
import { CircleSkeletonLoaderComponent } from './components/circle-skeleton-loader/circle-skeleton-loader.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { TopPanelComponent } from './components/top-panel/top-panel.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ReportFilterComponent } from './components/report-filter/report-filter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { FilterComponent } from './components/filter/filter.component';
import { LineChartComponent } from './components/line-chart/line-chart.component';
import { NgChartsModule } from 'ng2-charts';

const COMPONENTS = [
    LoaderComponent,
    MatSnackbarComponent,
    SvgToMatIconPipe,
    TextTruncatePipe,
    SidebarComponent,
    HeaderComponent,
    FormErrorMessageComponent,
    MapComponent,
    TableComponent,
    ModalHeaderComponent,
    ModalFooterComponent,
    PaginationComponent,
    LineSkeletonLoaderComponent,
    CircleSkeletonLoaderComponent,
    TopPanelComponent,
    BreadcrumbComponent,
    ReportFilterComponent,
    ReportCommonFilterComponent,
    FilterComponent,
    LineChartComponent,
    IotIntelligenceCardComponent,
];

@NgModule({
    declarations: [...COMPONENTS],
    imports: [
        CommonModule,
        MaterialModule,
        RouterModule,
        PaginatorModule,
        NgxSkeletonLoaderModule,
        FormsModule,
        MatNativeDateModule,
        MatDatepickerModule,
        ReactiveFormsModule,
        NgChartsModule,
    ],
    exports: [...COMPONENTS, MaterialModule],
    providers: [{ provide: JWT_OPTIONS, useValue: JWT_OPTIONS }, JwtHelperService],
})
export class SharedModule {}
